export const width = 418;
export const height = 310;
export default __webpack_public_path__ + "static/6.62ddcfdd.svg";